import React, { useEffect } from 'react'
import HomeDemoMaterialRequest from 'app/components/demoMaterial/HomeDemoMaterialRequest'
import { DemoMaterialRequestScreenProps } from 'app/routes/types'

const DemoMaterialRequest = ({
  navigation,
  route,
}: DemoMaterialRequestScreenProps) => {
  const resetFilters = route.params?.resetFilters ?? false

  useEffect(() => {
    if (resetFilters) {
      navigation.setParams({ resetFilters: false })
    }
  }, [resetFilters, navigation])

  return (
    <HomeDemoMaterialRequest
      key={String(resetFilters)}
      resetFilters={resetFilters}
    />
  )
}

export default DemoMaterialRequest
